import React, { useState, useContext, useEffect } from "react";
import { Popup } from "react-map-gl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import Context from "../../context";
import API from "../../API";
import { makeStyles } from "@material-ui/core/styles";

function NewSurfSpotInfo(props) {
    const { setAddSurfSpot, setSurfSpots } = useContext(Context);

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [nameError, setNameError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const { loc, address, fetchTimer } = props;
    if (!loc) return <div>No Loc</div>;

    useEffect(() => {
        if (address) {
            setAddressError(false);
        }
    }, [address]);

    return (
        <Popup
            offsetTop={-50}
            tipSize={15}
            anchor="bottom"
            longitude={loc.longitude}
            latitude={loc.latitude}
            closeOnClick={false}
            onClose={() => setAddSurfSpot(false)}
        >
            {/* Submitting Loader */}
            {submitting && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: "0px",
                        top: "0px",
                        left: "0px",
                        right: "0px",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress size={150} />
                </Box>
            )}
            {/* Lat Lng Data */}
            <LatLng loc={loc} fetchTimer={fetchTimer} addressError={addressError} address={address} />

            {/* Surf Spot Name */}
            <SurfSpotName nameError={nameError} name={name} setNameError={setNameError} setName={setName} />

            {/* Surf Spot Description */}

            <SurfSpotDesc
                setDescription={setDescription}
                descriptionError={descriptionError}
                description={description}
                setDescriptionError={setDescriptionError}
            />

            {/* Add Btn TODO: bug, this as a component never finishes fetching */}
            <Grid item container xs={12}>
                <Grid item xs={6}>
                    <Button onClick={() => setAddSurfSpot(false)} variant="text" color="error">
                        Cancel
                    </Button>
                </Grid>

                <Grid item xs={6}>
                    <Button
                        onClick={async () => {
                            //validate input
                            setSubmitting(true);
                            let err = false;
                            if (!name) {
                                console.log("no name");
                                setNameError(true);
                                err = true;
                            }
                            if (!description) {
                                console.log("no description");
                                setDescriptionError(true);
                                err = true;
                            }

                            // if (!address) {
                            //     console.log("no address");
                            //     setAddressError(true);
                            //     err = true;
                            // }
                            if (err) {
                                setSubmitting(false);

                                return;
                            }

                            try {
                                const resp = await API.postNewSurfSpot({
                                    name,
                                    description,
                                    address,
                                    latitude: loc.latitude,
                                    longitude: loc.longitude,
                                });
                                //validate response
                                console.log(resp);
                                if (resp.err) {
                                    console.log("got an error");
                                    console.log(resp.err);
                                } else {
                                    setAddSurfSpot(false);

                                    setSurfSpots((surfSpots) => [...surfSpots, resp]);
                                }
                                setSubmitting(false);
                            } catch (err) {
                                console.log(err);
                                setSubmitting(false);
                            }
                        }}
                        variant="contained"
                        color="success"
                    >
                        ADD
                    </Button>
                </Grid>
            </Grid>
            {/* End of Add Btn */}
        </Popup>
    );
}

export default NewSurfSpotInfo;

// HELPERS TODO MOVE THEM SOMEWHERE ELSE

const inputContainerStyles = { background: "#333" };

const inputStyles = {
    color: "white",
};

const inputProps = {
    autoComplete: "off",
    style: inputStyles,
};
const SurfSpotDesc = ({ descriptionError, description, setDescriptionError, setDescription }) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiFormLabel-root": {
                color: "red", // or black
            },
        },
    }));
    const classes = useStyles();

    return (
        <Grid item xs={12} sx={inputContainerStyles}>
            <TextField
                // className={classes.root}
                inputProps={inputProps}
                fullWidth
                error={descriptionError}
                aria-label="empty textarea"
                placeholder="Description"
                required
                minRows={3}
                maxRows={6}
                multiline
                style={{ width: 200, color: "white" }}
                type="text"
                value={description}
                onChange={(e) => {
                    debugger;
                    if (descriptionError) {
                        setDescriptionError(false);
                    }
                    setDescription(e.target.value);
                }}
            />
        </Grid>
    );
};

const SurfSpotName = ({ nameError, name, setNameError, setName }) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiFormLabel-root": {
                color: "white", // or black
            },
        },
    }));
    const classes = useStyles();
    return (
        <Grid item xs={12} sx={inputContainerStyles}>
            <TextField
                inputProps={inputProps}
                fullWidth
                error={nameError}
                required
                id="standard-basic"
                placeholder="Surf Sport Name"
                variant="standard"
                value={name}
                type="text"
                onChange={(e) => {
                    if (nameError) {
                        setNameError(false);
                    }
                    setName(e.target.value);
                }}
            />
        </Grid>
    );
};

const SurfSpotAddress = ({ fetchTimer, address, addressError }) => {
    return (
        <Grid
            item
            container
            xs={6}
            sx={{
                textAlign: "center",
                justifyContent: "center",
                display: "flex",
            }}
        >
            {/* Place holder for no address */}
            {!address && !fetchTimer && (
                <Grid
                    item
                    sx={{
                        fontSize: 12,
                        fontWeight: "bold",
                        color: addressError ? "red" : "inherit",
                    }}
                    xs={12}
                >
                    Place the icon on the surf spot
                </Grid>
            )}
            {/* Loader */}
            {fetchTimer && (
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            )}

            {/* Google Address Resp */}
            {!fetchTimer && address && (
                <Grid item xs={12}>
                    <Grid
                        item
                        sx={{
                            fontSize: 12,
                            fontWeight: "bold",
                            // textAlign: "center",
                        }}
                    >
                        {address}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

const LatLng = ({ loc, fetchTimer, addressError, address }) => {
    return (
        <Grid container sx={{ maxWidth: 200, position: "relative" }}>
            <Grid item container xs={6}>
                <Grid item sx={{ fontSize: 12, fontWeight: "bold" }} xs={12}>
                    <div>{`LAT: ${loc.latitude.toFixed(5)}`} </div>
                </Grid>

                <Grid item sx={{ fontSize: 12, fontWeight: "bold" }} xs={12}>
                    <div>{`LON: ${loc.longitude.toFixed(5)}`} </div>
                </Grid>
            </Grid>
            <SurfSpotAddress fetchTimer={fetchTimer} address={address} addressError={addressError} />
        </Grid>
    );
};
